module.exports = __webpack_public_path__ + "2fc4362c47d4f9203eed6cd6c5514b8e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/rus.svg
// module id = 62
// module chunks = 0